import React, { useState } from 'react';
import { FaChevronDown } from 'react-icons/fa';
import './FAQSection.css';

const faqData = [
  {
    question: 'What is RSKPay?',
    answer: 'RSKPay is an all-in-one digital payment app where users can do mobile recharges, pay utility bills, book bus tickets, buy gift cards, and shop online from one place.'
  },
  {
    question: 'How do I recharge my mobile using RSKPay?',
    answer: 'Open the app → select Mobile Recharge → enter your mobile number → choose operator and plan → make payment. The recharge is processed instantly.'
  },
  {
    question: 'Which bills can I pay through RSKPay?',
    answer: 'You can pay multiple utility bills including electricity, water, gas, broadband, and other supported services directly from the app.'
  },
  {
    question: 'Can I book bus tickets on RSKPay?',
    answer: 'Yes. RSKPay allows users to search routes, compare bus operators, and book intercity bus tickets within the app.'
  },
  {
    question: 'Does RSKPay provide cashback or rewards?',
    answer: 'Yes. Users can earn rewards or cashback on selected transactions like recharges, bill payments, and shopping depending on ongoing offers.'
  },
  {
    question: 'Is RSKPay safe for payments?',
    answer: 'RSKPay uses secure payment gateways and encrypted transactions to ensure user payments are protected.'
  },
  {
    question: 'What kind of shopping can I do on RSKPay?',
    answer: 'Users can purchase products directly through the shopping section available inside the RSKPay app without needing to switch to another platform.'
  },
  {
    question: 'Can I buy gift cards through RSKPay?',
    answer: 'Yes. RSKPay allows users to purchase digital gift cards from various brands, which can be used for shopping or gifting.'
  },
  {
    question: 'Are insurance and credit card services available on RSKPay?',
    answer: 'Not yet. Insurance and credit card services are currently planned and will be launched soon in upcoming updates.'
  },
  {
    question: 'What should I do if my recharge or payment fails?',
    answer: 'If a transaction fails but the amount is deducted, the money is usually automatically refunded within the defined refund timeline. You can also contact support through the app.'
  },
  {
    question: 'How can I contact RSKPay customer support?',
    answer: 'You can reach support directly from the Help & Support section inside the RSKPay app. Simply open the app, go to the support section, and raise your issue.'
  },
  {
    question: 'Where can I check my transaction history?',
    answer: 'All your recharges, bill payments, shopping orders, and bookings are available in the Transaction History section inside the app.'
  },
  {
    question: 'What should I do if my payment was deducted but the service was not completed?',
    answer: 'First check your transaction status in the app. If the payment failed, the amount is usually refunded automatically. If the issue continues, contact support through the Help section.'
  },
  {
    question: 'How long does a refund take on RSKPay?',
    answer: 'Refund timelines depend on the payment provider, but most failed transactions are automatically refunded within the standard banking timeline.'
  },
  {
    question: 'Can I raise a complaint about a failed recharge or booking?',
    answer: 'Yes. You can submit a complaint directly from the Help & Support section by selecting the specific transaction and describing the issue.'
  }
];

function FAQSection() {
  const [activeSection, setActiveSection] = useState(null);

  const toggleSection = (index) => {
    setActiveSection(activeSection === index ? null : index);
  };

  return (
    <section id="faq" className="faq-section">
      <div className="faq-container">
        <h1>
          <span>Frequently Asked</span>
          <span className="text-gradient"> Questions</span>
        </h1>
        
        <div className="faq-content">
          <div className="faq-accordion">
            {faqData.map((item, index) => (
              <div key={index} className="faq-item">
                <button
                  className={`faq-header ${activeSection === index ? 'active' : ''}`}
                  onClick={() => toggleSection(index)}
                  aria-expanded={activeSection === index}
                >
                  {item.question}
                  <FaChevronDown 
                    className={`faq-toggle ${activeSection === index ? 'active' : ''}`}
                  />
                </button>
                
                {activeSection === index && (
                  <div className="faq-body">
                    <p className="faq-answer">{item.answer}</p>
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}

export default FAQSection;
